import type { Track } from './types';

type Action =
  | 'play'
  | 'pause'
  | 'previoustrack'
  | 'nexttrack'
  | 'seekbackward'
  | 'seekforward'
  | 'seekto';

export function setSessionMetadata(track: Track): void {
  if (typeof navigator === 'undefined' || !('mediaSession' in navigator)) return;
  try {
    navigator.mediaSession.metadata = new MediaMetadata({
      title: track.title,
      artist: track.artist,
      album: track.albumTitle ?? 'Bhajans',
      artwork: track.artworkUrl
        ? [{ src: track.artworkUrl, sizes: '512x512', type: 'image/jpeg' }]
        : [],
    });
  } catch {
    /* ignore */
  }
}

export function setSessionState(playing: boolean): void {
  if (typeof navigator === 'undefined' || !('mediaSession' in navigator)) return;
  try {
    navigator.mediaSession.playbackState = playing ? 'playing' : 'paused';
  } catch {
    /* ignore */
  }
}

export function bindActions(handlers: Partial<Record<Action, (details?: MediaSessionActionDetails) => void>>): void {
  if (typeof navigator === 'undefined' || !('mediaSession' in navigator)) return;
  for (const action of Object.keys(handlers) as Action[]) {
    try {
      navigator.mediaSession.setActionHandler(action, (details) => handlers[action]?.(details));
    } catch {
      /* unsupported on this browser */
    }
  }
}
